<div>
  @for (recentItem of displayedActivity; track recentItem) {
    <div class="pad-20 flex items-center">
      <span><ds-date-circle [dateString]="recentItem.date"></ds-date-circle></span>
      <span class="margin-left-20">{{ recentItem.message }}</span>
    </div>
  }
  @if (displayedActivity.length === 3 && activityData.length > 3) {
    <div class="row pad-20">
      <a href="javascript:void(0)" (click)="toggleRecentItemsDisplay()">View All</a>
    </div>
  }
  @if (displayedActivity.length > 3) {
    <div class="row pad-20">
      <a href="javascript:void(0)" (click)="toggleRecentItemsDisplay(3)">Collapse Activity</a>
    </div>
  }
</div>
